
import { Link } from "react-router-dom";

const newsTitle = "Voulez-vous recevoir un e-mail à propos des offres spéciales et des mises à jour ?";
const siteTitle = "Plan du site";
const useTitle = "Liens utiles";
const socialTitle = "Réseaux sociaux";
const supportTitle = "Notre support";


const siteList = [
    {
        text: 'Documentation',
        link: '#',
    },
    {
        text: 'Feedback',
        link: '#',
    },
    {
        text: 'Plugins',
        link: '#',
    },
    {
        text: "Forums de support",
        link: '#',
    },
    {
        text: 'Thèmes',
        link: '#',
    },
]

const useList = [
    {
        text: 'À propos de nous',
        link: '#',
    },
    {
        text: 'Lien d\'aide',
        link: '#',
    },
    {
        text: 'Mentions légales',
        link: '#',
    },
    {
        text: 'Contactez-nous',
        link: '#',
    },
    {
        text: 'Politique de confidentialité',
        link: '#',
    },
]

const socialList = [
    {
        text: 'Facebook',
        link: '#',
    },
    {
        text: 'Twitter',
        link: '#',
    },
    {
        text: 'Instagram',
        link: '#',
    },
    {
        text: 'YouTube',
        link: '#',
    },
    {
        text: 'Github',
        link: '#',
    },
]

const supportList = [
    {
        text: 'Centre d\'aide',
        link: '#',
    },
    {
        text: 'Payé avec Mollie',
        link: '#',
    },
    {
        text: 'Statut',
        link: '#',
    },
    {
        text: 'Journal des modifications',
        link: '#',
    },
    {
        text: 'Contactez le support',
        link: '#',
    },
]



const Footer = () => {
    return (
        <div className="news-footer-wrap">
            <div className="fs-shape">
                <img src="assets/images/shape-img/03.png" alt="fst" className="fst-1" />
                <img src="assets/images/shape-img/04.png" alt="fst" className="fst-2" />
            </div>
            
            <div className="news-letter">
                <div className="container">
                    <div className="section-wrapper">
                        <div className="news-title">
                            <h3>{newsTitle}</h3>
                        </div>
                        <div className="news-form">
                            <form action="/">
                                <div className="nf-list">
                                    <input type="email" name="email" placeholder="Entrez votre Email" />
                                    <input type="submit" name="submit" value="Abonnez-vous" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            <footer>
                <div className="footer-top padding-tb pt-0">
                    <div className="container">
                        <div className="row g-4 row-cols-xl-4 row-cols-md-2 row-cols-1 justify-content-center">
                            {/*<div className="col">*/}
                            {/*    <div className="footer-item">*/}
                            {/*        <div className="footer-inner">*/}
                            {/*            <div className="footer-content">*/}
                            {/*                <div className="title">*/}
                            {/*                    <h4>{siteTitle}</h4>*/}
                            {/*                </div>*/}
                            {/*                <div className="content">*/}
                            {/*                    <ul className="lab-ul">*/}
                            {/*                        {siteList.map((val, i) => (*/}
                            {/*                            <li key={i}><a href={val.link}>{val.text}</a></li>*/}
                            {/*                        ))}*/}
                            {/*                    </ul>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>{useTitle}</h4>
                                            </div>
                                            <div className="content">
                                                <ul className="lab-ul">
                                                    {useList.map((val, i) => (
                                                        <li key={i}><a href={val.link}>{val.text}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>{socialTitle}</h4>
                                            </div>
                                            <div className="content">
                                                <ul className="lab-ul">
                                                    {socialList.map((val, i) => (
                                                        <li key={i}><a href={val.link}>{val.text}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>{supportTitle}</h4>
                                            </div>
                                            <div className="content">
                                                <ul className="lab-ul">
                                                    {supportList.map((val, i) => (
                                                        <li key={i}><a href={val.link}>{val.text}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom style-2">
                    <div className="container">
                        <div className="section-wrapper">
                            <p>
                                <Link to="/">Cotracall </Link>
                                &nbsp;&nbsp;&nbsp;
                                &copy; 2022
                                <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; tous droits réservés</b>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
 
export default Footer;